import Vue from 'vue';
import store from '@/store';
import StoreProxy from "../../../proxies/StoreProxy";
import * as types from './mutation-types';

/**
 * 지역리스트
 * @param commit
 */
export const getAreaList = ({ commit }) => {
  new StoreProxy()
    .getAreaList()
    .then((response) => {
      commit(types.AREAS, response);
    });
};

/**
 * 매장 등록
 * @param commit
 * @param param
 */
export const createStore = ({ commit }, param) => {
  new StoreProxy()
    .create(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'StoreManagement'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 매장 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {
  new StoreProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

/**
 * 업체 수정
 * @param commit
 * @param param
 */
export const editStore = ({ commit }, param) => {
  new StoreProxy()
    .update(param.storeSeq, param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'StoreManagement'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

export const findAllStoreFloors = ({ commit }, storeSeq) => {
  new StoreProxy()
    .findAllStoreFloors(storeSeq)
    .then((response) => {
      commit(types.FLOORS, response);
    });
};

/**
 * 점포현황 (광고)
 * @param commit
 * @param param
 */
export const getStoreMediaList = ({ commit }, param) => {
  new StoreProxy(param)
    .getStoreMediaList(param.storeSeq, param.storeFloorSeq)
    .then((response) => {
      commit(types.MEDIAS, response);
    });
};

/**
 * 점포현황 (광고) 초기화
 * @param commit
 * @param param
 */
export const initStoreMediaList = ({ commit }) => {
    let response = {medias: []};
    commit(types.MEDIAS, response);
};


export default {
  getAreaList,
  createStore,
  findAll,
  editStore,
  findAllStoreFloors,
  getStoreMediaList,
  initStoreMediaList,
};
